export default {
  path: "/SectionContent/CollisionDetails",
  name: "Collision Details & Circumstances",
  htmlContent: "collision_details_and_circumstances.html",
  headings: [
    { id: "n46FirstHarmfulEvent", text: "46. First Harmful Event", type: "field" },
    { id: "n47MostHarmfulEvent", text: "47. Most Harmful Event", type: "field" },
    { id: "n52DirectionOfTravel", text: "52. Direction of Travel", type: "field" },
    { id: "n53VehicleManeuver", text: "53. Vehicle Maneuver", type: "field" },
    { id: "n54NonMotoristManeuver", text: "54. Non-Motorist Maneuver", type: "field" },
    { id: "n57VisionObscuredBy", text: "57. Vision Obscured By", type: "field" },
    { id: "n88MannerOfCollision", text: "88. Manner of Collision", type: "field" },
    { id: "n89LocationAtAreaOfImpact", text: "89. Location at Area of Impact", type: "field" },
    { id: "n90Weather", text: "90. Weather", type: "field" },
    { id: "n91SurfaceCondition", text: "91. Surface Condition", type: "field" },
    { id: "n92LightConditions", text: "92. Light Conditions", type: "field" },
  ],
};
